import { useTranslation } from 'react-i18next'
import { ConfidentialRecordMenuItem } from '@omnea-app/fe-authz/ConfidentialRecordMenuItem'
import { RequestDetailQueryKey } from '../../../../useRequestDetail'

type Props = {
  requestId: string
  isConfidential: boolean | undefined
  onClose?: () => void
}

export const ConfidentialMenuItem = ({ requestId, isConfidential, onClose }: Props) => {
  const { t } = useTranslation('requests')

  if (isConfidential == null) return null

  return (
    <ConfidentialRecordMenuItem
      entity="request"
      recordId={requestId}
      isConfidential={isConfidential}
      permission="canAdminister"
      invalidateKeys={[[RequestDetailQueryKey, requestId]]}
      onClose={onClose}
      translateCopy={(key) => t(`confidentiality.${key}`)}
      labels={{ mark: t('manage-request.mark-confidential'), unmark: t('manage-request.unmark-confidential') }}
    />
  )
}
